<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
// @ is an alias to /src

export default {
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      // 刷新页面
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    });
  },
  mounted() {
    // 会导致所有页面重复两次mounted调用，导致接口重复调用
    // 改为针对特定路由使用
    window.addEventListener(
      "hashchange",
      () => {
        // 解决查看作品详情页会导致浏览器前进后退页面内容不会重载的bug
        let currentPath = window.location.hash.slice(1);
        if (currentPath.indexOf("info") > -1) {
          this.reload();
        }
        // console.log(11111)
        // let currentPath = window.location.hash.slice(1);
        // console.log(this.$route.path, currentPath)
        // if (this.$route.path !== currentPath) {
        //   // router.push(currentPath);
        //   location.reload();
        // }
      },
      false
    );
  },
};
</script>
<style>
@import "./static/css/style.css";
</style>
